import Auth from '../modules/Authentication'
import { apiUrl } from '../variables'
import { handleErrors, handleResponse } from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const CatalogsApi = {
  list: () => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}catalogs/?select=*`, { headers }).then(handleErrors).then(handleResponse)
  },
  display: () => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}catalogs/display/?select=*`, { headers }).then(handleErrors).then(handleResponse)
  },
  products: (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}catalogs/${key}/products`, { headers }).then(handleErrors).then(handleResponse)
  },
  mergeProducts: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}catalogs/mergeProducts`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  },
  create: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}catalogs/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}catalogs/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  remove: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}catalogs/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  },
  lines: {
    list: () => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}catalogs/lines/`, { headers }).then(handleErrors).then(handleResponse)
    },
    create: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}catalogs/lines/`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}catalogs/lines/`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    remove: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}catalogs/lines/`, {
        headers: headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  },
}
